module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-10-18 at 21.39.12_bbe8cd12.85f47671.jpg";